export const WINDOW_RESIZE = '@@app/WINDOW_RESIZE';



/** WEBPACK FOOTER **
 ** ./src/constants/index.js
 **/